const normalizePropertyKeys = (properties: any[]): any[] => {
  if (!properties || !Array.isArray(properties)) return [];

  return properties.map((property: any) => {
    const { id, Id, propertyId, ...rest } = property;
    return {
      ...rest,
      propertyId: propertyId || id || Id,
    };
  });
};

export { normalizePropertyKeys };
